import { useNavigate } from "react-router-dom";
import type { NavigateFunction } from "react-router-dom";

/**
 * Hook sécurisé pour useNavigate() qui fonctionne même sans Router
 * Utilisé dans les composants partagés qui peuvent être utilisés dans différentes contexts
 */
export function useSafeNavigate(): NavigateFunction {
  try {
    return useNavigate();
  } catch (error) {
    // On n'est pas dans un Router, on retourne une fonction no-op
    return () => {
      console.warn("useSafeNavigate: Navigation not available without Router context");
    };
  }
}
